import { ArrowRight, Check } from 'lucide-react';
import { Button } from './ui/button';

const partnerBenefits = [
  'Understands platforms from the inside',
  'Builds systems instead of chasing trends',
  'Thinks in years, not campaigns',
];

export const FinalCTA = () => {
  return (
    <section
      data-testid="final-cta-section"
      className="relative py-24 md:py-32 bg-gradient-to-br from-primary/5 via-white to-primary/5 overflow-hidden"
    >
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-primary/5 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mx-auto text-center">
          {/* Headline */}
          <h2
            className="font-oswald uppercase tracking-tight font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight"
            data-testid="final-cta-headline"
          >
            <span className="text-gray-900">If you want another agency,</span>
            <br />
            <span className="text-primary">keep scrolling.</span>
          </h2>

          {/* Subtext */}
          <div className="mt-8">
            <p className="font-manrope text-lg text-gray-500">
              If you want a partner who:
            </p>

            {/* Benefits */}
            <ul className="mt-6 space-y-4 text-left max-w-md mx-auto">
              {partnerBenefits.map((benefit, idx) => (
                <li
                  key={idx}
                  className="font-manrope text-base text-gray-700 flex items-center gap-3"
                >
                  <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
                    <Check className="w-4 h-4 text-white" />
                  </div>
                  {benefit}
                </li>
              ))}
            </ul>
          </div>

          {/* CTA */}
          <div className="mt-12">
            <a
              href="https://calendly.com/atabdullah-mah/30min"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-cta-button"
            >
              <Button className="bg-primary text-white hover:bg-primary/90 rounded-full px-10 py-7 text-lg font-bold uppercase tracking-wide btn-scale glow-primary inline-flex items-center gap-3">
                Start a Conversation
                <ArrowRight size={20} />
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
